module.exports = __webpack_public_path__ + "static/media/B_F03.895f85a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/B_F03.png
// module id = 12
// module chunks = 0